import React from 'react';

interface MarkdownLinkedTextProps {
  text: string;
  paragraphClassName?: string;
  paragraphStyle?: React.CSSProperties;
  linkClassName?: string;
  linkStyle?: React.CSSProperties;
}

interface InlineMarkdownTextProps {
  text: string;
  linkClassName?: string;
  linkStyle?: React.CSSProperties;
}

const markdownLinkPattern = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;

function InlineMarkdownText({
  text,
  linkClassName,
  linkStyle,
}: InlineMarkdownTextProps): React.JSX.Element {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  markdownLinkPattern.lastIndex = 0;
  let match = markdownLinkPattern.exec(text);

  while (match) {
    const [fullMatch, label, href] = match;
    const matchIndex = match.index ?? 0;

    if (matchIndex > lastIndex) {
      nodes.push(text.slice(lastIndex, matchIndex));
    }

    nodes.push(
      <a
        key={`${href}-${matchIndex}`}
        href={href}
        className={linkClassName}
        style={linkStyle}
        target='_blank'
        rel='noopener noreferrer'
      >
        {label}
      </a>,
    );

    lastIndex = matchIndex + fullMatch.length;
    match = markdownLinkPattern.exec(text);
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return <>{nodes}</>;
}

export default function MarkdownLinkedText({
  text,
  paragraphClassName,
  paragraphStyle,
  linkClassName,
  linkStyle,
}: MarkdownLinkedTextProps): React.JSX.Element {
  return (
    <>
      {text.split('\n\n').map((paragraph, paragraphIndex) => {
        const lines = paragraph.split('\n');

        return (
          <p key={paragraphIndex} className={paragraphClassName} style={paragraphStyle}>
            {lines.map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                <InlineMarkdownText
                  text={line}
                  linkClassName={linkClassName}
                  linkStyle={linkStyle}
                />
                {lineIndex < lines.length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        );
      })}
    </>
  );
}
